import { NetworkIdSchema } from "#network/network.js";
import z$1 from "zod";
//#region src/cards/announcementBanner.ts
const AnnouncementBannerSchema = z$1.object({
	id: z$1.string(),
	networkId: NetworkIdSchema.optional(),
	title: z$1.string(),
	description: z$1.string(),
	primaryCta: z$1.object({
		url: z$1.string(),
		label: z$1.string()
	}).optional(),
	secondaryCta: z$1.object({
		url: z$1.string(),
		label: z$1.string()
	}).optional(),
	publishedAt: z$1.string().datetime(),
	imageUrl: z$1.string().url().optional(),
	imageFit: z$1.enum(["cover", "contain"]).optional(),
	backgroundColor: z$1.string().optional()
});
//#endregion
export { AnnouncementBannerSchema };

//# sourceMappingURL=announcementBanner.js.map